import { Box, CircularProgress } from "@chakra-ui/react";

export const LoadingScreen = () => {
  return (
    <Box
      h="100vh"
      w="100vw"
      display="flex"
      justifyContent="center"
      alignItems="center"
      bg="slate.50"
    >
      <CircularProgress isIndeterminate color="blue.500" size={6} />
    </Box>
  );
};
